import get from 'lodash/get';
import {useState} from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';

import CustomHelperText from './CustomHelperText';

const handleClick = ({setIsChecked, onChange}) => e => {
  const checked = get(e, 'target.checked');
  setIsChecked(checked);
  onChange({target: {value: checked, checked}});
};

const CustomCheckbox = props => {
  const [checked, setIsChecked] = useState(props.defaultValue || false);
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            disabled={props.disabled}
            sx={{color: 'text.gray'}}
            checked={checked}
            onChange={handleClick({setIsChecked, onChange: props.onChange})}
          />
        }
        label={props.label}
      />
      {!!props?.helperText && (
        <CustomHelperText>
          {props.helperText}
        </CustomHelperText>
      )}
    </FormGroup>
  );
};

export default CustomCheckbox;
